import { GroupedInterventions, Intervention } from '@/app/components/action-plan/types';

export const groupByMonth = (interventions: Intervention[]) => {
  return interventions.reduce((groups: GroupedInterventions, item) => {
    const yearMonth = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short' }).format(
      new Date(item.completedAt)
    );

    if (!groups[yearMonth]) {
      groups[yearMonth] = [];
    }
    groups[yearMonth].push(item);

    groups[yearMonth].sort((a, b) => new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime());

    return groups;
  }, {});
};

export const formatDate = (date: string) => new Intl.DateTimeFormat('en-US').format(new Date(date));
